import { Fragment, useContext, useEffect, useState } from 'react';
import UserContext from '../../context/userContext';
import ReservationContext from '../../context/reservationContext';
import obtenerReservaciones from '../../services/obtenerReservaciones';
import { Loading } from '../Common/Loading';
import { useNavigate } from 'react-router';
import { Heading, Button, Checkbox } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const Reservaciones = () => {
  
  const { t } = useTranslation();

  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const { setReservation } = useContext(ReservationContext);
  const [reservaciones, setReservaciones] = useState([]);
  const [includeOld, setIncludeOld] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const editReservation = (resData) => {
    setReservation(resData);
    navigate(`/manejar-reservaciones/${resData.id}`);
  };

  useEffect(() => {
    if (user.admin) return;
    requestReservations();
  }, [user, includeOld]);

  const requestReservations = async () => {
    setIsLoading(true);
    obtenerReservaciones(user.id, includeOld)
      .then((res) => {
        if (res.status === 200) {
          setReservaciones(res.data.reservaciones);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      });
  };


  if (isLoading && !user.admin)
    return (
      <div className="position-relative h-100">
        <Loading />
      </div>
    );

  return (
    <div>
      {user.admin ? (
        <iframe
          title="campina"
          src="https://app.reservatio.com.mx/client/#/login"
          width="100%"
          height="900px"
        />
      ) : (
        <div className="mt-lg-3 mx-lg-5 m-2">
          <Fragment>
            <div className="d-flex justify-content-between align-items-center">
            <Heading
              size="lg"
              mb="4"
            >
                {t('MY_RESERVATIONS')}
            </Heading>
            <Button
              colorScheme="blue"
              onClick={() => navigate('/reservar-ahora')}
              mb="4"
            >
                {t('RESERVE_NOW')}
            </Button>
          </div>
          <div>
            <Checkbox
              isChecked={includeOld}
              onChange={() => setIncludeOld(!includeOld)}
            >
              {t('INCLUDE_OLD_RESERVATIONS')}
            </Checkbox>
          </div>
        </Fragment>
          {
            reservaciones.length === 0 && !isLoading ? (
              <Fragment>
                
                <div className="d-flex justify-content-center align-items-center h-100 mt-5 flex-column">
                <Heading
                  mt={10}
                  size={'lg'}
                >
                    {t('NO_RESERVATIONS_YET')}
                </Heading>
                {/* <Button
                  colorScheme="blue"
                  onClick={() => navigate('/reservar-ahora')}
                  mt={5}
                >
                  Reservar ahora
                </Button> */}
              </div>
            </Fragment>
            )
            :(
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{t('RESERVATION_TYPE')}</th>
                      <th>{t('ARRIVAL_DATE')}</th>
                      <th>{t('DEPARTURE_DATE')}</th>
                      <th>{t('GUEST_NAME')}</th>
                      <th>{t('CABIN_TYPE')}</th>
                      <th>{t('TOKEN')}</th>
                      <th>{t('TRANSACTION_NUMBER')}</th>
                      <th></th>
                    </tr>
                  </thead>
                  {
                    <tbody>
                      {
                        reservaciones.map((reservacion) => {
                          const oldDate = new Date(reservacion.fechaSalida) < new Date();
                          return (
                            <tr key={reservacion.id} style={ oldDate ? { opacity: '.5' } : {}}>
                              <td>
                                {reservacion.tipoReservacion === 'OTRACABANA'
                                  ? 'ADICIONALES'
                                  : reservacion.tipoReservacion === 'CORTESIA'
                                  ? 'CORTESÍA'
                                  : reservacion.tipoReservacion}
                              </td>
                              <td>{reservacion.fechaLlegada.split('T')[0]}</td>
                              <td>{reservacion.fechaSalida.split('T')[0]}</td>
                              <td>{reservacion.nombreQuienReserva}</td>
                              <td>{reservacion.tipoCabana}</td>
                              <td>{reservacion.token}</td>
                              <td>{reservacion.numeroTransaccion}</td>
                              {(
                                reservacion.tipoReservacion && !oldDate &&
                                (reservacion.tipoReservacion.toLowerCase() === 'titular' ||
                                reservacion.tipoReservacion.toLowerCase() === 'cotitular' ||
                                reservacion.tipoReservacion.toLowerCase() === 'cortesia')) && (
                                <td>
                                  <Button
                                    colorScheme={'orange'}
                                    onClick={() => {
                                      editReservation(reservacion);
                                    }}
                                  >
                                    {t('MANAGE_RESERVATION')}
                                  </Button>
                                </td>
                              )}
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  }
                </table>
              </div>
            )
          }
        </div>
      )}
    </div>
  );
};

export default Reservaciones;
